import * as THREE from 'three';
import {
  CARD1Web,
} from '../../CoordUtils.js';

import {
  ModelLoader
} from '@/drawings3D/ModelLoader';

//这个类用来载入路牌所需要的各种贴图，使用canvas实现
export class WorkerLoader extends ModelLoader {
  constructor(workerOption, sceneManager) {
    var modelInfo = {
        modelPath: '/static/bimroad/3DModels/worker/',
        name: 'worker',
        extraPartConfig:{
          option:workerOption
        }
      }
    super(sceneManager, modelInfo);
  }

  loadExtraParts(extraPart, loadedMesh) {
     loadedMesh.oInfo = extraPart.option.option.info;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/WorkerLoader.js